<template slot-scope="scope">
  <!-- 代开发票 弹窗组件 -->
  <dialogModel
    title="开具发票"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
    width="700px"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="single-choice">
        <div class="title"><span style="color: red">*</span>发票性质：</div>
        <div
          class="Select-choice firm-clickable"
          v-for="(item, index) in listArr"
          :key="index"
          @click="ruleForm.listArrSelect = item.id"
        >
          <div
            :class="
              item.id == ruleForm.listArrSelect
                ? 'Select-style'
                : 'notSelect-style'
            "
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="pull-down">
        <div class="title"><span style="color: red">*</span>发票信息：</div>
        <div class="cen-div">
          <el-form-item prop="value">
            <el-select
              v-model="ruleForm.value"
              placeholder="请选择发票信息"
              no-data-text="暂无发票信息"
              @change="handleHeadChange"
            >
              <el-option
                v-for="item in headList"
                :key="item.id"
                :label="item.headName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="single-choice">
        <div class="title"><span style="color: red">*</span>默认发票类型：</div>
        <div
          class="Select-choice firm-clickable"
          v-for="(item, index) in listArr1"
          :key="index"
          @click="ruleForm.listArrSelect1 = item.id"
        >
          <div
            :class="
              item.id == ruleForm.listArrSelect1
                ? 'Select-style'
                : 'notSelect-style'
            "
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="single-choice">
        <div class="title">是否展示：</div>
        <div
          class="Select-choice firm-clickable"
          v-for="(item, index) in showFlagList"
          :key="index"
          @click="ruleForm.showFlag = item.id"
        >
          <div
            :class="
              item.id == ruleForm.showFlag ? 'Select-style' : 'notSelect-style'
            "
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="single-choice">
        <div class="title">是否发送邮箱：</div>
        <div
          class="Select-choice firm-clickable"
          v-for="(item, index) in sendMailList"
          :key="index"
          @click="handleSendMailChange(item.id)"
        >
          <div
            :class="
              item.id == ruleForm.sendMail ? 'Select-style' : 'notSelect-style'
            "
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div
        class="pull-down"
        v-if="ruleForm.listArrSelect == 0 && ruleForm.sendMail == 1"
      >
        <div class="title"><span style="color: red">*</span>选择邮箱：</div>
        <div class="cen-div">
          <el-form-item prop="value1">
            <el-select
              v-model="ruleForm.value1"
              placeholder="请选择邮箱"
              no-data-text="暂无邮箱"
            >
              <el-option
                v-for="item in mailList"
                :key="item.id"
                :label="item.mail"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="pull-down" v-else-if="ruleForm.listArrSelect != 0">
        <div class="title"><span style="color: red">*</span>选择地址：</div>
        <div class="cen-div">
          <el-form-item prop="value2">
            <el-select
              v-model="ruleForm.value2"
              placeholder="请选择地址"
              no-data-text="暂无地址"
            >
              <el-option
                v-for="item in addressList"
                :key="item.id"
                :label="item.address"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="pull-down" v-if="isReissue">
        <div class="title"><span style="color: red">*</span>重开原因：</div>
        <div class="cen-div">
          <el-form-item prop="renewReason">
            <el-input
              v-model="ruleForm.renewReason"
              type="textarea"
              placeholder="请输入重开原因"
              :rows="3"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <!-- 销售方信息 -->
      <div class="seller-info" v-if="sellerInfo && isBatch">
        <div class="seller-title">销售方信息</div>
        <div class="seller-detail">
          <div><span>企业名称：</span>{{ sellerInfo.companyName || "-" }}</div>
          <div>
            <span>统一社会信用代码：</span>{{ sellerInfo.creditCode || "-" }}
          </div>
          <div><span>地址：</span>{{ sellerInfo.address || "-" }}</div>
          <div>
            <span>开户行名称：</span
            >{{ sellerInfo.bankName || sellerInfo.sellerBankName || "-" }}
          </div>
          <div>
            <span>开户行账号：</span
            >{{
              sellerInfo.bankAccount || sellerInfo.sellerBankAccount || "-"
            }}
          </div>
          <div><span>电话：</span>{{ sellerInfo.phone || "-" }}</div>
        </div>
      </div>
    </el-form>
  </dialogModel>
</template>

<script>
// 引入接口
import { getSellerInfoByServiceType } from "../../../../../assets/api/Agency/Enterprise";

export default {
  props: {
    dialogVisible: {},
    select: {},
    num: {},

    headList: {}, // 抬头选项
    addressList: {}, // 地址选项
    mailList: {}, //邮箱选项
    acquiesce: {}, // 默认
    isReissue: {
      type: Boolean,
      default: false,
    }, // 是否重新开票
    isBatch: {
      type: Boolean,
      default: false,
    }, // 是否批量操作
  },
  components: {},
  data() {
    return {
      listArr: [
        { name: "电子发票", id: "0" },
        // { name: "纸质发票", id: "1" },
      ], // 发票性质：电子/纸质
      listArr1: [
        { name: "增值税普通发票", id: "0" },
        { name: "增值税专用发票", id: "1" },
      ], // 发票类型：普票/专票
      showFlagList: [
        { name: "否", id: "0" },
        { name: "是", id: "1" },
      ], // 是否展示
      sendMailList: [
        { name: "否", id: "0" },
        { name: "是", id: "1" },
      ], // 是否发送邮箱
      options: [], // 搜索下拉框数据
      sellerInfo: null, // 销售方信息
      ruleForm: {
        listArrSelect: "0", // 选中发票性质 0电子1纸质
        listArrSelect1: "0", // 选中发票类型 0普1专
        value: "", // 发票信息
        value1: "", // 选择邮箱
        value2: "", // 选择地址
        showFlag: "0", // 是否展示 0否 1是
        sendMail: "0", // 是否发送邮箱 0否 1是
        renewReason: "", // 重开原因
      },
      rules: {
        value: [
          {
            required: true,
            message: "请选择发票信息",
            trigger: ["blur", "change"],
          },
        ],
        value1: [
          {
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.listArrSelect == 0 &&
                this.ruleForm.sendMail == 1 &&
                !value
              ) {
                callback(new Error("请选择邮箱"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        value2: [
          {
            required: true,
            message: "请选择地址",
            trigger: ["blur", "change"],
          },
        ],
        renewReason: [
          {
            validator: (rule, value, callback) => {
              if (!this.isReissue) {
                callback();
                return;
              }
              if (!value || !String(value).trim()) {
                callback(new Error("请填写重开原因"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
    };
  },
  watch: {
    dialogVisible: {
      handler(newSs, old) {
        if (newSs == true) {
          this.resetForm();
          this.getSellerInfo();
        } else {
          this.sellerInfo = null;
          this.resetForm();
        }
      },
      immediate: false,
    },
    // 监听
    acquiesce: {
      handler(newSs, old) {
        this.applyAcquiesce(newSs);
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    getDefaultRuleForm() {
      return {
        listArrSelect: "0",
        listArrSelect1: "0",
        value: "",
        value1: "",
        value2: "",
        showFlag: "0",
        sendMail: "0",
        renewReason: "",
      };
    },
    resetForm() {
      this.sellerInfo = null;
      this.ruleForm = this.getDefaultRuleForm();
      this.applyAcquiesce(this.acquiesce);
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    applyAcquiesce(data) {
      if (!data) return;
      this.ruleForm.value = data.head != null ? data.head.id : "";
      this.ruleForm.value1 = data.mail != null ? data.mail.id : "";
      this.ruleForm.value2 = data.address != null ? data.address.id : "";
      this.syncInvoiceTypeByHeadId(this.ruleForm.value, data.head);
    },
    // 根据选中抬头同步默认发票类型
    syncInvoiceTypeByHeadId(headId, headObj) {
      let invoiceType = null;
      if (headObj && headObj.invoiceType !== undefined && headObj.invoiceType !== null) {
        invoiceType = headObj.invoiceType;
      } else if (headId !== undefined && headId !== null && headId !== "") {
        const head = (this.headList || []).find((item) => item.id == headId);
        if (head && head.invoiceType !== undefined && head.invoiceType !== null) {
          invoiceType = head.invoiceType;
        }
      }
      if (invoiceType !== null) {
        this.ruleForm.listArrSelect1 = String(invoiceType);
      }
    },
    handleHeadChange(headId) {
      this.syncInvoiceTypeByHeadId(headId);
    },
    handleSendMailChange(id) {
      this.ruleForm.sendMail = id;
      if (id == 1) {
        if (!this.ruleForm.value1 && this.acquiesce && this.acquiesce.mail) {
          this.ruleForm.value1 = this.acquiesce.mail.id;
        }
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate("value1");
          }
        });
      } else {
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate("value1");
          }
        });
      }
    },
    // 获取销售方信息
    async getSellerInfo() {
      // 只有批量操作时才调用接口
      if (!this.isBatch) {
        this.sellerInfo = null;
        return;
      }
      this.sellerInfo = null;
      var data = {
        data: {
          consumptionType: this.num,
        },
      };
      try {
        const res = await getSellerInfoByServiceType(data);
        if (res.code == 0) {
          this.sellerInfo = res.data || null;
        } else {
          this.sellerInfo = null;
        }
      } catch (e) {
        this.sellerInfo = null;
      }
    },
    // 取消关闭弹窗
    handleClose() {
      this.$emit("handleCloseDele", this.dialogVisible);
      //   this.dialogVisible = false;
    },
    // 确认
    handleUnderstand(unlockConfirm, lockConfirm) {
      const unlock =
        typeof unlockConfirm === "function" ? unlockConfirm : null;
      const lock = typeof lockConfirm === "function" ? lockConfirm : null;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.isReissue && !String(this.ruleForm.renewReason || "").trim()) {
            this.$tool.PromptBox("warning", "请填写重开原因");
            return;
          }
          // 校验通过后再进入加载，防止连点重复提交
          lock && lock();
          const payload = {
            ...this.ruleForm,
            renewReason: String(this.ruleForm.renewReason || "").trim(),
          };
          this.$emit("handleUnderstand", payload, unlock);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/* 验证失败红色边框 */
/deep/ .el-form-item.is-error .el-input__inner {
  border-color: #fe574a !important;
}
/deep/.el-textarea .el-input__count {
  bottom: -30px !important;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/deep/.el-form-item__error {
  padding-top: 2px;
  line-height: 1.2;
}
.demo-ruleForm {
  width: 500px;
  margin: 0 auto;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  div {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}

.single-choice {
  height: 35px;
  margin-right: auto;
  margin-bottom: 10px;
  display: flex;
  .title {
    width: 110px;
    height: 35px;
    line-height: 35px;
    text-align: right;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
}
.Select-choice {
  margin-left: 5px;
  margin-right: 30px;
  display: flex;
  align-items: center;
  .notSelect-style {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-image: url("../../../../../assets/imgs/weigouxuan@3x.svg");
    background-size: 100% 100%;
    cursor: pointer;
  }
  .Select-style {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
    background-size: 100% 100%;
    cursor: pointer;
  }
  div {
    line-height: 18px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    margin-left: 10px;
  }
}
.pull-down {
  min-height: 35px;
  margin-right: auto;
  margin-bottom: 4px;
  display: flex;
  .title {
    width: 110px;
    line-height: 35px;
    text-align: right;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    flex-shrink: 0;
  }
  .cen-div {
    width: 350px;
    min-height: 35px;
    line-height: 35px;
    /deep/.el-input__inner {
      height: 35px !important;
      font-size: 14px;
      border: 1px solid #409eff ;
    }
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}

// 销售方信息样式
.seller-info {
  width: 100%;
  padding: 0;
  margin-right: auto;

  .seller-title {
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
  }

  .seller-detail {
    div {
      font-size: 14px;
      color: #666666;
      line-height: 26px;
      margin: 10px 0;
      display: flex;

      span {
        color: #333333;
        font-weight: 400;
        width: 130px;
        text-align: right;
        flex-shrink: 0;
      }
    }
  }
}
</style>
